import React, { SyntheticEvent } from 'react';

import ProductsCarousel, {
  ProductsCarouselProps,
} from 'components/Common/Carousel/ProductsCarousel/ProductsCarousel';
import ProductCardColors from 'components/Common/Card/ProductCard/ProductCardColors/ProductCardColors';
import ProductCardContainer from 'components/Common/Card/ProductCard/ProductCardContainer/ProductCardContainer';
import ProductCardDetails from 'components/Common/Card/ProductCard/ProductCardDetails/ProductCardDetails';
import ProductCardDiscount from 'components/Common/Card/ProductCard/ProductCardDiscount/ProductCardDiscount';
import ProductCardImage from 'components/Common/Card/ProductCard/ProductCardImage/ProductCardImage';
import ProductCardLabel from 'components/Common/Card/ProductCard/ProductCardLabel/ProductCardLabel';
import ProductCardPrice from 'components/Common/Card/ProductCard/ProductCardPrice/ProductCardPrice';
import ProductCardStickers from 'components/Common/Card/ProductCard/ProductCardStickers/ProductCardStickers';
import { CarouselPushProductType } from 'types/Carousel';

import styles from './PushProductsCarousel.module.scss';

type PushProductsCarousel = {
  onProductClick?: (
    product: CarouselPushProductType,
    e: SyntheticEvent
  ) => void;
} & ProductsCarouselProps<CarouselPushProductType>;

type ProductPropsType = {
  product: CarouselPushProductType;
  onClick?: (product: CarouselPushProductType, e: SyntheticEvent) => void;
};

export default function PushProductsCarousel({
  onProductClick,
  ...props
}: PushProductsCarousel): JSX.Element {
  function renderProduct(product: CarouselPushProductType): JSX.Element {
    return <Product product={product} onClick={onProductClick} />;
  }

  return (
    <ProductsCarousel
      classes={{ wrapper: styles.carouselWrapper }}
      renderProduct={renderProduct}
      {...props}
    />
  );
}

function Product({ product, onClick }: ProductPropsType): JSX.Element {
  const {
    colorSwatch,
    brand,
    discountPercentage,
    discountPrice,
    price,
    lotQuantity,
    shortLabel,
    stickerMain,
    stickerSub,
    stickerSub2,
    url,
    visuelFace,
  } = product;

  return (
    <ProductCardContainer
      linkTo={url}
      onClick={e => onClick?.(product, e)}
      className={styles.card}
    >
      <ProductCardImage images={[{ alt: shortLabel, src: visuelFace }]}>
        {discountPercentage && parseInt(discountPercentage) > 0 && (
          <ProductCardDiscount discountPercentage={discountPercentage} />
        )}
        <ProductCardStickers
          mainSticker={stickerMain}
          subSticker1={stickerSub}
          subSticker2={stickerSub2}
          classes={{ sticker: styles.sticker }}
        />
      </ProductCardImage>
      <ProductCardDetails className={styles.details}>
        <ProductCardColors
          colors={colorSwatch}
          nbDisplay={5}
          className={styles.colorsContainer}
          classes={{
            colorBubble: { container: styles.colorBubbleContainer },
          }}
        />
        <div className={styles.labelPriceContainer}>
          <ProductCardLabel
            brand={brand}
            label={shortLabel}
            className={styles.labelContainer}
          />
          <ProductCardPrice
            discountPrice={discountPrice}
            price={price}
            lotQuantity={lotQuantity}
            classes={{ priceFrom: styles.priceFrom }}
          />
        </div>
      </ProductCardDetails>
    </ProductCardContainer>
  );
}
